import styles from "../../../styles/modal.module.css"
import DishWidget from "../../DishWidget";

import {getIcon} from "../../../utils/helper";
import {useEffect} from "react";

const ModalContact = (props) => {
    const {setOpenModal,openModal} = props;

    useEffect(() => {
        // Khi modal mở, thêm class 'modal-open' vào body
        if (openModal) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }

        // Cleanup function: loại bỏ class khi component unmount
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [openModal]);
    return (
        <div className={`${openModal ? styles.activeModal : ""} ${styles.modalContainer}`}>
            <div className={styles.modalContent}>
                <DishWidget/>
                <div className={styles.closeIcon} onClick={() => setOpenModal(false)}>
                    {getIcon("close")}
                </div>
            </div>

        </div>
    )
}
export default ModalContact;